export default __webpack_public_path__ + "static/B0063-0491742c335029ae4fb6216364927dc4.png";